import type { ProductContent } from "@itaas/pep-contracts";
import { PEP_API_BASE } from "../config";
import {
  adminFetch,
  getAdminKey,
  getIamToken,
} from "../admin/admin-api";

export function fetchProductContent(slug: string) {
  return adminFetch<ProductContent>(`/admin/product-content/${encodeURIComponent(slug)}`);
}

export function saveProductContent(slug: string, patch: Partial<ProductContent>) {
  return adminFetch<ProductContent>(`/admin/product-content/${encodeURIComponent(slug)}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export function addProductFormation(
  slug: string,
  body: { title: string; description?: string; durationMin?: number },
) {
  return adminFetch<ProductContent>(`/admin/product-content/${encodeURIComponent(slug)}/formations`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateProductFormation(
  slug: string,
  formationId: string,
  patch: Record<string, unknown>,
) {
  return adminFetch<ProductContent>(
    `/admin/product-content/${encodeURIComponent(slug)}/formations/${encodeURIComponent(formationId)}`,
    { method: "PATCH", body: JSON.stringify(patch) },
  );
}

export function deleteProductFormation(slug: string, formationId: string) {
  return adminFetch<ProductContent>(
    `/admin/product-content/${encodeURIComponent(slug)}/formations/${encodeURIComponent(formationId)}`,
    { method: "DELETE" },
  );
}

export function reorderProductFormations(slug: string, orderedIds: string[]) {
  return adminFetch<ProductContent>(
    `/admin/product-content/${encodeURIComponent(slug)}/formations-reorder`,
    { method: "PATCH", body: JSON.stringify({ orderedIds }) },
  );
}

export async function uploadProductMedia(
  slug: string,
  file: File,
  opts: { target: "presentation" | "formation"; formationId?: string; title?: string },
) {
  const iamToken = getIamToken();
  const key = getAdminKey();
  const form = new FormData();
  form.append("file", file);
  form.append("target", opts.target);
  if (opts.formationId) form.append("formationId", opts.formationId);
  if (opts.title) form.append("title", opts.title);

  const headers: Record<string, string> = {};
  if (iamToken) headers.Authorization = `Bearer ${iamToken}`;
  else if (key) headers["x-pep-admin-key"] = key;

  const res = await fetch(
    `${PEP_API_BASE}/admin/product-content/${encodeURIComponent(slug)}/upload`,
    { method: "POST", headers, body: form },
  );
  if (!res.ok) throw new Error(`Upload échoué: ${res.status}`);
  return res.json() as Promise<ProductContent>;
}
